<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header page-title="EMPENHOS EXTRA-ORÇAMENTÁRIA"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/invoice1.png">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/empenhos-extra']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button *ngIf="entidade.id" data-toggle="modal" data-target="#dialogAnular"
            class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/coins_delete.png" alt="Anular" title="Anular empenho" height="22" width="22">
          </button>
          <button (click)="submitForm()" type="submit" class="btn btn-info float-right mr-4"
            style="font-size: 13px">Salvar empenho</button>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-3">
              <label for="numero_empenho" class="mr-2" style="font-weight: bold; color: #009688 ">Empenho Nº:</label>
              <input id="numero_empenho" formControlName="numero" type="text" class="form-control" readonly
                style="font-weight: bold; color: #1e88e5; text-align: right;">
            </div>
            <div class="col-md-3">
              <label for="data_empenho">Data empenho<span class="text-danger">*</span></label>
              <p-calendar id="data_empenho" formControlName="data_empenho" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" dateFormat="dd/mm/yy" [showIcon]="true"
                [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="col-md-3">
              <label for="data_vencimento">Previsão Pagto</label>
              <p-calendar id="data_vencimento" formControlName="data_vencimento" inputStyleClass="form-control"
                dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                [showButtonBar]="true" [style]="{ width: '100%' }">
              </p-calendar>
            </div>
            <div class="col-md-3">
              <label for="contrato">Contrato</label>
              <p-autoComplete formControlName="contrato" [field]="contratoAutoComplete.conversor"
                [suggestions]="contratoAutoComplete.lista" (completeMethod)="contratoAutoComplete.filtrar($event)"
                inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }" [forceSelection]="true"
                [autoHighlight]="true" *ngIf="contratoAutoComplete">
                <ng-template let-contrato pTemplate="item">
                  {{contrato.numero}}
                </ng-template>
              </p-autoComplete>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="ficha" style="display: block">Ficha extra de despesa<span class="text-danger">*</span></label>
              <div class="col-md-3 p-0 float-left">
                <input class="form-control" type="text" (blur)="fichaAutoComplete.atualizar(false)"
                  [(ngModel)]="fichaAutoComplete.id" name="ficha_id" [ngModelOptions]="{standalone: true}" />
              </div>
              <div class="form-group col-md-9 p-0 float-left">
                <p-autoComplete formControlName="ficha" [field]="fichaAutoComplete.conversor"
                  [suggestions]="fichaAutoComplete.lista" (completeMethod)="fichaAutoComplete.filtrar($event)"
                  placeholder="Informe a ficha extra" inputStyleClass="form-control" minLength="2"
                  [style]="{ width: '100%' }" (onSelect)="fichaAutoComplete.atualizar(true)"
                  (onBlur)="fichaAutoComplete.atualizar(true)" [forceSelection]="true" [autoHighlight]="true"
                  *ngIf="fichaAutoComplete">
                  <ng-template let-ficha pTemplate="item">
                    {{ficha.numero}} {{ficha.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
          <hr class="mt-0 mb-3" />
          <div class="form-row">
            <div class="col-md-12">
              <label for="favorecido" class="font-weight-bold" style="display: block">Favorecido<span
                  class="text-danger">*</span></label>
              <div class="form-group col-md-3 p-0 float-left">
                <input class="form-control font-weight-bold" type="text"
                  (blur)="favorecidoAutoComplete.atualizar(false)" [(ngModel)]="favorecidoAutoComplete.id"
                  name="favorecido_id" [ngModelOptions]="{standalone: true}" />
              </div>
              <div class="form-group col-md-9 p-0 float-left">
                <p-autoComplete formControlName="favorecido" [field]="favorecidoAutoComplete.conversor"
                  [suggestions]="favorecidoAutoComplete.lista" (completeMethod)="favorecidoAutoComplete.filtrar($event)"
                  placeholder="informe o favorecido" inputStyleClass="form-control font-weight-bold" minLength="2"
                  [style]="{ width: '100%' }" (onSelect)="favorecidoAutoComplete.atualizar(true)"
                  [forceSelection]="true" [autoHighlight]="true" *ngIf="favorecidoAutoComplete">
                  <ng-template let-favorecido pTemplate="item">
                    {{favorecido.cpf_cnpj | CPF}} {{favorecido.nome}}
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-3">
              <label for="valor_empenho">Valor empenho<span class="text-danger">*</span></label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_empenho" type="text"
                class="form-control text-right" id="valor_empenho" placeholder="0,00"
                style="font-weight: bold; color: #1e88e5">
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <div class="row">
            <div class="col-md-3">
              <label for="processo">N˚ Processo<span class="text-danger">*</span></label>
              <input formControlName="processo" type="text" class="form-control" id="processo">
            </div>
            <div class="col-md-3">
              <label for="documento">Documento</label>
              <input formControlName="documento" type="text" class="form-control" id="documento">
            </div>

          </div>
        </div>
        <div class="col-md-4">
          <div class="card mb-3">
            <ul class="list-group list-group-flush">
              <li class="list-group-item">Empenhado <span class="float-right">{{empenhado | number:'1.2-2'}}</span></li>
              <li class="list-group-item">Pago <span class="float-right">{{pago | number:'1.2-2'}}</span></li>
            </ul>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <app-retencao-extra [(lista)]="listaRetencoes" [data_vencimento]="entidadeForm.get('data_vencimento').value" [login]="login"></app-retencao-extra>
      <div class="row">
        <div class="col-md-12">
          <label for="historico">Histórico<span class="text-danger">*</span></label>
          <textarea formControlName="historico" class="form-control" id="historico" rows="5"></textarea>
        </div>
      </div>
    </div>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<app-empenho-extra-anulacao *ngIf="entidade.id" [login]="login" [empNumero]="entidade.numero">
</app-empenho-extra-anulacao>